import { z } from 'zod';
/**
 * Money and other exact numbers cross the wire as **strings with a fixed scale** (SDD §10.3).
 * A JSON number would already have lost precision by the time any code could check it, so no DTO
 * field that carries an amount, price, total, balance, rate or quantity is ever a number.
 */
const decimalString = (scale, label) => z
    .string()
    .regex(new RegExp(`^-?\\d{1,17}\\.\\d{${scale}}$`), `${label} must be a decimal string with exactly ${scale} decimal places`);
/** Monetary amounts: AED to fils, `numeric(19,2)` (SDD §9.1). */
export const AmountSchema = decimalString(2, 'Amount');
/** Unit prices: `numeric(19,4)`. */
export const PriceSchema = decimalString(4, 'Price');
/** Quantities: `numeric(19,4)`. */
export const QuantitySchema = decimalString(4, 'Quantity');
/** Rates and ratios, carried as percentages: `numeric(9,6)` (e.g. `"5.000000"`). */
export const RateSchema = decimalString(6, 'Rate');
//# sourceMappingURL=money.js.map